// extracted by mini-css-extract-plugin
export default {"pageContent":"team_pageContent__YHMie"};